import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_CALCULATION_TYPE_REQUEST = 'FETCH_CALCULATION_TYPE_REQUEST';
export const FETCH_CALCULATION_TYPE_SUCCESS = 'FETCH_CALCULATION_TYPE_SUCCESS';
export const FETCH_CALCULATION_TYPE_FAILURE = 'FETCH_CALCULATION_TYPE_FAILURE';

export const calculationTypeSchema = new schema.Entity(
  'calculationTypes',
  {},
  { idAttribute: 'slug' },
);

/**
 * Returns a redux api middleware action that makes a request to create a filter.
 *
 * @param {object} values - New filter field values.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchCalculationTypes = () =>
  createAction({
    endpoint: `${window.config.apiUrl}/calculation-types`,
    method: 'GET',
    types: [
      { type: FETCH_CALCULATION_TYPE_REQUEST },
      {
        type: FETCH_CALCULATION_TYPE_SUCCESS,
        payload: (action, state, res) =>
          handleResponse([calculationTypeSchema], action, state, res),
      },
      { type: FETCH_CALCULATION_TYPE_FAILURE, payload: handleError },
    ],
  });
